import { render, staticRenderFns } from "./TeamPetitionsIndex.vue?vue&type=template&id=5339bac2"
import script from "./TeamPetitionsIndex.vue?vue&type=script&lang=js"
export * from "./TeamPetitionsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports